import { FadeIn } from "./FadeIn";
import { PRACTICAL } from "@/content";

export const Practical = () => (
  <section data-testid="practical-section" className="bg-[#F6F5F2] px-6 py-20 lg:px-10 lg:py-28">
    <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
      {[PRACTICAL.technology, PRACTICAL.availability].map((block, i) => (
        <FadeIn key={block.label} delay={i * 0.08}>
          <div data-testid={`practical-${block.label.toLowerCase()}`} className="h-full border border-[#D8D4CA] bg-white p-8 md:p-10">
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#D18237]">{block.label}</p>
            <p className="mt-4 text-sm leading-[1.9] text-[#4A525B] md:text-base">{block.body}</p>
          </div>
        </FadeIn>
      ))}
    </div>
  </section>
);
